'use client';

import { c as _c } from "react/compiler-runtime";
import PopupComponent, { type PopupComponentRef, PopupType } from '@spa/components/popup/popup.component';
import { ReactElement, useRef } from 'react';
import ButtonComponent from '@spa/components/button/button/button.component';
import { ButtonType } from '@spa/components/button/types/ButtonType';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { createPortal } from 'react-dom';
import styles from './bazaarvoice-review-terms-modal.component.module.scss';
import useHasOpenedOnce from '@spa/lib/react/hooks/useHasOpenedOnce';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly isOpen: boolean;
  readonly onClosed: () => void;
}
function BazaarvoiceReviewTermsModalComponent(t0) {
  const $ = _c(24);
  const {
    isOpen,
    onClosed
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("bazaarvoice-review-terms-modal");
  const hasOpened = useHasOpenedOnce(isOpen);
  const popupRef = useRef(null);
  if (!hasOpened) {
    return null;
  }
  let t1;
  if ($[0] !== formatMessage) {
    t1 = formatMessage("headline");
    $[0] = formatMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== formatMessage) {
    t2 = formatMessage("sectionHeadline");
    $[2] = formatMessage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <h3 className={styles["bazaarvoice-review-terms-modal__section-headline"]}>{t2}</h3>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== formatMessage) {
    t4 = formatMessage("body");
    $[6] = formatMessage;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <div className={styles["bazaarvoice-review-terms-modal__body"]} dangerouslySetInnerHTML={{
      __html: t4
    }} />;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== formatMessage) {
    t6 = formatMessage("closeButton");
    $[10] = formatMessage;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => popupRef.current?.close();
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <ButtonComponent buttonType={ButtonType.PRIMARY} text={t6} onClick={t7} />;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t5 || $[17] !== t8) {
    t9 = <div className={styles["bazaarvoice-review-terms-modal"]}>{t3}{t5}{t8}</div>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== isOpen || $[20] !== onClosed || $[21] !== t1 || $[22] !== t9) {
    t10 = createPortal(<PopupComponent ref={popupRef} isOpen={isOpen} onClosed={onClosed} focusDialogOnOpen={true} closable={true} popupType={PopupType.DEFAULT} title={t1}>{t9}</PopupComponent>, document.body);
    $[19] = isOpen;
    $[20] = onClosed;
    $[21] = t1;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}
export default BazaarvoiceReviewTermsModalComponent;